import React, { useState, useEffect, useContext, useRef } from "react";
import "../../../../constants/report.css";
import axios from "axios";
import { AuthContext } from "../../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../../contexts/ContextProvider";
import { Loader } from "../../../../components";
import { formatDate } from "../../../../constants/helper";
import {
  Box,
  ButtonGroup,
  Button,
  Autocomplete,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";
import { Container, Form, Row, Col, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import { useDownloadExcel } from "react-export-table-to-excel";
import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";
import { useReactToPrint } from "react-to-print";
import useScreenWidth from "../../../../hooks/useScreenWidth";

const LaporanPenjualanPerStok = () => {
  const screenSize = useScreenWidth();
  const tableRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const reportTemplateRef = useRef(null);
  let nowDate = new Date();
  let [sampaiTanggal, setSampaiTanggal] = useState(
    new Date(user.tutupperiode.sampaiTanggal)
  );
  let [dariTanggal, setDariTanggal] = useState(
    new Date(user.tutupperiode.dariTanggal)
  );
  const [kodeCabang, setKodeCabang] = useState("");
  const [namaCabang, setNamaCabang] = useState("");
  const [kodeJenisStok, setKodeJenisStok] = useState("");

  const [cabangs, setCabangs] = useState([]);
  const [jenisStoks, setJenisStoks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [persenLoading, setPersenLoading] = useState("0");
  const [lapPenjualanPerHaris, setLapPenjualanPerHaris] = useState([]);
  const [previewPdf, setPreviewPdf] = useState(false);
  const [isCetakExcel, setIsCetakExcel] = useState(false);
  const [error, setError] = useState(false);

  const [filter, setFilter] = useState("REKAP");

  const handleChangeFilter = (event) => {
    setFilter(event.target.value);
    setPreviewPdf(false);
  };

  let cabangOptions = cabangs.map((cabang) => ({
    label: `${cabang.id} - ${cabang.namaCabang}`,
    id: `${cabang.id} - ${cabang.namaCabang}`,
  }));

  let jenisStokOptions = jenisStoks.map((jenisStok) => ({
    label: `${jenisStok.kodeJenisStok} - ${jenisStok.namaJenisStok}`,
  }));

  useEffect(() => {
    getJenisStokData();
  }, []);

  const getJenisStokData = async () => {
    const response = await axios.post(`${tempUrl}/jenisStoks`, {
      _id: user.id,
      token: user.token,
    });
    setJenisStoks(response.data);
  };

  const generatePDF = useReactToPrint({
    content: () => reportTemplateRef.current,
    documentTitle: "LaporanPenjualanPerStok",
  });

  const tampilPdf = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setLoading(true);
      let tempPersenLoading = parseInt(persenLoading);

      setTimeout(() => {
        tempPersenLoading += 40;
        setPersenLoading(tempPersenLoading.toString());
      }, "1000");

      if (filter === "REKAP") {
        let laporanPenjualanPerStok = await axios.post(
          `${tempUrl}/laporanPenjualanPerStokRekap`,
          {
            dariTanggal,
            sampaiTanggal,
            kodeJenisStok: kodeJenisStok.split(" ", 1)[0],
            kodeCabang,
            _id: user.id,
            token: user.token,
          }
        );
        setLapPenjualanPerHaris(laporanPenjualanPerStok.data);
        setPreviewPdf(!previewPdf);
        setLoading(false);
        setTimeout(() => {
          tempPersenLoading = 0;
          setPersenLoading(tempPersenLoading.toString());
        }, "2000");
      } else {
        let laporanPenjualanPerStok = await axios.post(
          `${tempUrl}/laporanPenjualanPerStokRinci`,
          {
            dariTanggal,
            sampaiTanggal,
            kodeJenisStok: kodeJenisStok.split(" ", 1)[0],
            kodeCabang,
            _id: user.id,
            token: user.token,
          }
        );
        setLapPenjualanPerHaris(laporanPenjualanPerStok.data);
        setPreviewPdf(!previewPdf);
        setLoading(false);
        setTimeout(() => {
          tempPersenLoading = 0;
          setPersenLoading(tempPersenLoading.toString());
        }, "2000");
      }
    }
  };

  useEffect(() => {
    getCabangsData();
    if (user.tipeUser !== "OWNER/DIREKSI") {
      setKodeCabang(user.cabang.id);
      setNamaCabang(`${user.cabang.id} - ${user.cabang.namaCabang}`);
    }
  }, []);

  const getCabangsData = async () => {
    const response = await axios.post(`${tempUrl}/cabangs`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setCabangs(response.data);
  };

  const tableText = {
    letterSpacing: "0.01px",
  };

  const textBold = {
    fontWeight: 700,
    border: "1px solid black",
  };

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  const textNumberRight = {
    textAlign: "right",
    border: "1px solid black",
  };

  const textNumberRightBold = {
    textAlign: "right",
    fontWeight: 700,
    border: "1px solid black",
  };

  const list = [];

  if (filter === "REKAP") {
    let tempTotalTotalQuantity = 0;
    let tempTotalTotalHargaNetto = 0;

    Object.entries(lapPenjualanPerHaris).map(([jenisTitle, stokRows]) => {
      list.push(
        <tr style={{ ...tableText, fontWeight: "bold" }}>
          <td
            style={{ paddingLeft: "15px", border: "1px solid black" }}
            colSpan={4}
          >
            Jenis : {jenisTitle}
          </td>
        </tr>
      );

      let tempSubtotalTotalQuantity = 0;
      let tempSubtotalTotalHargaNetto = 0;

      stokRows.map((row, index) => {
        tempSubtotalTotalQuantity += row.totalQuantity;
        tempSubtotalTotalHargaNetto += row.totalHargaNetto;

        tempTotalTotalQuantity += row.totalQuantity;
        tempTotalTotalHargaNetto += row.totalHargaNetto;
        list.push(
          <tr style={tableText}>
            <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
              {index + 1}
            </td>
            <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
              {row.groupStokTitle}
            </td>
            <td style={textNumberRight}>
              {isCetakExcel === false
                ? row.totalQuantity.toLocaleString("en-EN")
                : row.totalQuantity}
            </td>
            <td style={textNumberRight}>
              {isCetakExcel === false
                ? row.totalHargaNetto.toLocaleString("en-EN")
                : row.totalHargaNetto}
            </td>
          </tr>
        );
      });

      list.push(
        <tr style={{ ...tableText, fontWeight: "bold" }}>
          <td
            style={{ paddingLeft: "15px", border: "1px solid black" }}
            colSpan={2}
          >
            Sub Total : {jenisTitle}
          </td>
          <td style={textNumberRight}>
            {isCetakExcel === false
              ? tempSubtotalTotalQuantity.toLocaleString("en-EN")
              : tempSubtotalTotalQuantity}
          </td>
          <td style={textNumberRight}>
            {isCetakExcel === false
              ? tempSubtotalTotalHargaNetto.toLocaleString("en-EN")
              : tempSubtotalTotalHargaNetto}
          </td>
        </tr>
      );
    });

    list.push(
      <tr style={{ ...tableText, fontWeight: "bold" }}>
        <td
          style={{ paddingLeft: "15px", border: "1px solid black" }}
          colSpan={2}
        >
          Total :
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? tempTotalTotalQuantity.toLocaleString("en-EN")
            : tempTotalTotalQuantity}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? tempTotalTotalHargaNetto.toLocaleString("en-EN")
            : tempTotalTotalHargaNetto}
        </td>
      </tr>
    );
  } else {
    let tempTotalTotalQuantity = 0;
    let tempTotalTotalHargaNetto = 0;

    Object.entries(lapPenjualanPerHaris).map(([groupTitle, stokRows]) => {
      list.push(
        <tr style={{ ...tableText, fontWeight: "bold" }}>
          <td
            style={{ paddingLeft: "15px", border: "1px solid black" }}
            colSpan={4}
          >
            Grup : {groupTitle}
          </td>
        </tr>
      );

      let tempSubtotalTotalQuantity = 0;
      let tempSubtotalTotalHargaNetto = 0;

      stokRows.map((row, index) => {
        tempSubtotalTotalQuantity += row.totalQuantity;
        tempSubtotalTotalHargaNetto += row.totalHargaNetto;

        tempTotalTotalQuantity += row.totalQuantity;
        tempTotalTotalHargaNetto += row.totalHargaNetto;
        list.push(
          <tr style={tableText}>
            <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
              {index + 1}
            </td>
            <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
              {row.stokTitle}
            </td>
            <td style={textNumberRight}>
              {isCetakExcel === false
                ? row.totalQuantity.toLocaleString("en-EN")
                : row.totalQuantity}
            </td>
            <td style={textNumberRight}>
              {isCetakExcel === false
                ? row.totalHargaNetto.toLocaleString("en-EN")
                : row.totalHargaNetto}
            </td>
          </tr>
        );
      });

      list.push(
        <tr style={{ ...tableText, fontWeight: "bold" }}>
          <td
            style={{ paddingLeft: "15px", border: "1px solid black" }}
            colSpan={2}
          >
            Sub Total : {groupTitle}
          </td>
          <td style={textNumberRight}>
            {isCetakExcel === false
              ? tempSubtotalTotalQuantity.toLocaleString("en-EN")
              : tempSubtotalTotalQuantity}
          </td>
          <td style={textNumberRight}>
            {isCetakExcel === false
              ? tempSubtotalTotalHargaNetto.toLocaleString("en-EN")
              : tempSubtotalTotalHargaNetto}
          </td>
        </tr>
      );
    });

    list.push(
      <tr style={{ ...tableText, fontWeight: "bold" }}>
        <td
          style={{ paddingLeft: "15px", border: "1px solid black" }}
          colSpan={2}
        >
          Total :
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? tempTotalTotalQuantity.toLocaleString("en-EN")
            : tempTotalTotalQuantity}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? tempTotalTotalHargaNetto.toLocaleString("en-EN")
            : tempTotalTotalHargaNetto}
        </td>
      </tr>
    );
  }

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "LaporanPenjualanPerStok",
    sheet: "LaporanPenjualanPerStok",
  });

  if (loading) {
    return <Loader persenLoading={persenLoading} />;
  }

  return (
    <Container>
      <h3>Laporan</h3>
      <h5 style={{ fontWeight: 400 }}>Laporan Penjualan Per Stok</h5>
      <hr />
      <Box sx={spacingTop}>
        <Form onSubmit={tampilPdf}>
          <Row>
            <FormControl sx={{ marginTop: 1 }}>
              <FormLabel id="demo-controlled-radio-buttons-group">
                Filter
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                defaultValue="REKAP"
                value={filter}
                onChange={handleChangeFilter}
              >
                <FormControlLabel
                  value="REKAP"
                  control={<Radio />}
                  label="Rekap"
                />
                <FormControlLabel
                  value="RINCI"
                  control={<Radio />}
                  label="Rinci"
                />
              </RadioGroup>
            </FormControl>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Cabang :
                </Form.Label>
                <Col sm="8">
                  {user.tipeUser === "OWNER/DIREKSI" ? (
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={cabangOptions}
                      renderInput={(params) => (
                        <TextField
                          error={error && kodeCabang.length === 0 && true}
                          size="small"
                          placeholder="SEMUA CABANG"
                          {...params}
                        />
                      )}
                      onChange={(e, value) => {
                        if (value) {
                          setKodeCabang(value.id.split(" ", 1)[0]);
                          setNamaCabang(value.id);
                        } else {
                          setKodeCabang("");
                          setNamaCabang("");
                        }
                        setPreviewPdf(false);
                      }}
                      defaultValue={kodeCabang}
                    />
                  ) : (
                    <Form.Control value={kodeCabang} disabled readOnly />
                  )}
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Dari :
                </Form.Label>
                <Col sm="8">
                  <DatePicker
                    required
                    dateFormat="dd/MM/yyyy"
                    selected={dariTanggal}
                    customInput={<Form.Control required />}
                    onChange={(date) => {
                      setDariTanggal(date);
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Sampai :
                </Form.Label>
                <Col sm="8">
                  <DatePicker
                    required
                    dateFormat="dd/MM/yyyy"
                    selected={sampaiTanggal}
                    customInput={<Form.Control required />}
                    onChange={(date) => {
                      setSampaiTanggal(date);
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Jenis Stok :
                </Form.Label>
                <Col sm="8">
                  <Autocomplete
                    size="small"
                    disablePortal
                    id="combo-box-demo"
                    options={jenisStokOptions}
                    renderInput={(params) => (
                      <TextField
                        error={error && kodeJenisStok.length === 0 && true}
                        size="small"
                        {...params}
                      />
                    )}
                    onChange={(e, value) => {
                      if (value) {
                        setKodeJenisStok(value.label);
                      } else {
                        setKodeJenisStok("");
                      }
                      setPreviewPdf(false);
                    }}
                    value={kodeJenisStok}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Button
            variant="contained"
            startIcon={<SearchIcon />}
            type="submit"
            style={{ marginTop: "20px" }}
          >
            LIHAT
          </Button>
        </Form>
      </Box>

      {previewPdf && (
        <div style={{ marginTop: "10px" }}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button startIcon={<PrintIcon />} onClick={generatePDF}>
              PDF
            </Button>
            <Button
              startIcon={<SearchIcon />}
              onClick={() => {
                setIsCetakExcel(true);
                setTimeout(() => {
                  onDownload();
                }, "1000");
              }}
            >
              Excel
            </Button>
          </ButtonGroup>
        </div>
      )}
      <div ref={reportTemplateRef} id="content" style={pdfContainer}>
        <div style={{ visibility: previewPdf === true ? "visible" : "hidden" }}>
          <p>
            {setting.namaPerusahaan} - {setting.alamatPerusahaan}
          </p>
          <p>({setting.kabupatenPerusahaan})</p>
          <p>{setting.kotaPerusahaan}</p>
          <p>NO. TELP. {setting.teleponPerusahaan}</p>
          <p>
            Dicetak Oleh: {user.username} | Tanggal:
            {` ${nowDate.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(nowDate.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${nowDate.getFullYear()} `}{" "}
            | Jam:{" "}
            {` ${nowDate.getHours().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}:${(nowDate.getMinutes() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}:${nowDate.getSeconds().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })} `}
          </p>
          <h5 style={{ textAlign: "center", fontWeight: "700" }}>
            Laporan Penjualan Per Stok
          </h5>
          <p>
            Dari Tanggal :
            {` ${dariTanggal.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(dariTanggal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${dariTanggal.getFullYear()}`}
          </p>
          <p>
            Sampai Tanggal :
            {` ${sampaiTanggal.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(sampaiTanggal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${sampaiTanggal.getFullYear()}`}
          </p>
          <p>Jenis Stok : {kodeJenisStok ? kodeJenisStok : "SEMUA"}</p>
          <p>Cabang : {namaCabang}</p>
          <p></p>
          <table class="styled-table" ref={tableRef}>
            <thead>
              <tr>
                <th style={{ border: "1px solid black" }} rowSpan={2}>
                  NO.
                </th>
                <th style={{ border: "1px solid black" }} rowSpan={2}>
                  {filter === "REKAP" ? "GROUP STOK" : "STOK"}
                </th>
                <th
                  style={{ border: "1px solid black", textAlign: "center" }}
                  colSpan={2}
                >
                  OMSET
                </th>
              </tr>
              <tr>
                <th style={{ border: "1px solid black" }}>QTY</th>
                <th style={{ border: "1px solid black" }}>RUPIAH</th>
              </tr>
            </thead>
            <tbody>{list}</tbody>
          </table>
        </div>
      </div>
    </Container>
  );
};

export default LaporanPenjualanPerStok;

const spacingTop = {
  mt: 4,
};

const pdfContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "10px",
  fontFamily: "sans-serif",
  width: "1000px",
};
